import React from 'react'
import PropTypes from 'prop-types'
import TableHeader from './TableHeader'
import TableBody from './TableBody'

class TableItems extends React.Component {
    constructor(props) {
        super(props);
        this.topScrollRef = React.createRef();
        this.bottomScrollRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.state = {
            fixed: false,
        };
    }

    componentDidMount() {
        const topScroll = this.topScrollRef.current;
        const bottomScroll = this.bottomScrollRef.current;

        if (topScroll && bottomScroll) {
        this.topScrollHandler = () => {
            bottomScroll.scrollLeft = topScroll.scrollLeft;
        };
        this.bottomScrollHandler = () => {
            topScroll.scrollLeft = bottomScroll.scrollLeft;
        };

        topScroll.addEventListener("scroll", this.topScrollHandler);
        bottomScroll.addEventListener("scroll", this.bottomScrollHandler);
        }

        // lắng nghe scroll trang
        window.addEventListener("scroll", this.handleWindowScroll);
    }

    componentWillUnmount() {
        const topScroll = this.topScrollRef.current;
        const bottomScroll = this.bottomScrollRef.current;

        if (topScroll && bottomScroll) {
        topScroll.removeEventListener("scroll", this.topScrollHandler);
        bottomScroll.removeEventListener("scroll", this.bottomScrollHandler);
        }

        window.removeEventListener("scroll", this.handleWindowScroll);
    }

    handleWindowScroll = () => {
        if (!this.wrapperRef.current) return;

        const rect = this.wrapperRef.current.getBoundingClientRect();
        // nếu table đang đi ra khỏi viewport (top < 0) => stick
        if (rect.top < 0 && rect.bottom > 40) {
        if (!this.state.fixed) this.setState({ fixed: true });
        } else {
        if (this.state.fixed) this.setState({ fixed: false });
        }
    };

    render() {
        const {
            loading,
            items,
            sort,
            allSelected,
            selectedItems,
            onChangeSort,
            onChangeSelected,
            onResetBulkAll,
            onToggleSelectAll,
            onReloadItems,
            onOpenModalEdit,
            onOpenModalEditProduct,
            openModalMarkFaileDesign,
            itemsRequest,
            onOpenModalItemLabel,
            onChangeFilterTag,
            onOpenModalGenLabelCustomWHL,
            filter,
            onChangeFilter
        } = this.props
        const { fixed } = this.state;

        return (
            <div ref={this.wrapperRef}>
                <div
                ref={this.topScrollRef}
                className="scroll-top"
                style={{
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "5px",
                    position: fixed ? "fixed" : "static",
                    top: fixed ? "0" : "auto",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    zIndex: 1000,
                }}
                >
                {/* giả table rộng để sinh scroll */}
                    <div style={{ width: "1840px", height: "1px" }}></div>
                </div>
                <div className={`ListItemsTable ${loading ? 'ReloadTable' : ''}`} ref={this.bottomScrollRef}>
                    <div className='ListItemTableWrap'>
                        <TableHeader
                            items={items}
                            sort={sort}
                            selectedItems={selectedItems}
                            allSelected={allSelected}
                            onChangeSort={onChangeSort}
                            onReloadItems={onReloadItems}
                            onToggleSelectAll={onToggleSelectAll}
                            onResetBulkAll={onResetBulkAll}
                        />
                        <TableBody
                            items={items}
                            selectedItems={selectedItems}
                            openModalEdit={onOpenModalEdit}
                            openModalEditProduct={onOpenModalEditProduct}
                            reloadItems={onReloadItems}
                            handleChangeSelected={onChangeSelected}
                            openModalMarkFaileDesign={openModalMarkFaileDesign}
                            itemsRequest={itemsRequest}
                            onModalItemLabel={onOpenModalItemLabel}
                            onChangeFilterTag={onChangeFilterTag}
                            openModalGenLabelCustomWHL={onOpenModalGenLabelCustomWHL}
                            filter={filter}
                            onChangeFilter={onChangeFilter}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

TableItems.propTypes = {
    items: PropTypes.array.isRequired,
}

export default TableItems
